import { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

import { useAuth } from "scenes/Authentication/components/AuthProvider";
import { useAuthenticationManager } from "scenes/Authentication/hooks/useAuthenticationManager";

export const verifyCodeSchema = yup.object({
  code: yup.string().required("Verification code is required"),
});

export function useVerifyCodeForm({ email }) {
  const { confirmSignUp, resendSignUp, isProcessing } =
    useAuthenticationManager();
  const { autoSignIn } = useAuth();
  const [error, setError] = useState();
  const [submitted, setSubmitted] = useState(false);
  const history = useHistory();

  const run = async (action, defaultError) => {
    setError("");
    try {
      await action();
    } catch (err) {
      setError(err?.message || defaultError);
      setSubmitted(false);
    }
  };

  const formProps = useForm({
    resolver: yupResolver(verifyCodeSchema),
    mode: "onSubmit",
    defaultValues: { code: "" },
  });

  return {
    formProps: formProps,
    loading: isProcessing || (autoSignIn && submitted),
    error: error,
    confirmSignUp: async ({ code }) => {
      await run(async () => {
        setSubmitted(true);
        await confirmSignUp(email, code);
        if (!autoSignIn) history.push(`/v2${history.location.search}`);
      }, "Fail to confirm verification code.");
    },
    resendCode: async () => {
      await run(async () => {
        await resendSignUp(email);
      }, "Failed to resend code.");
    },
  };
}

export default useVerifyCodeForm;
